export enum UserType {
  DOCTOR = 'doctor',
  OPERATOR = 'operator',
}
